<template>
  <div id="createProject">
    <div class="header">立项管理</div>
    <div class="prjList">
      <el-form ref="form" :model="selectForm" inline class="prjList_form" size="small">
        <el-form-item label="项目编号">
          <el-input v-model="selectForm.prjCode" placeholder="项目编号查询" size="small" clearable
            @keyup.enter.native="fetchData(1)">
            <i slot="prefix" class="el-input__icon el-icon-search" @click="fetchData(1)" />
          </el-input>
        </el-form-item>
        <el-form-item label="项目名称">
          <el-input v-model="selectForm.prjName" placeholder="项目名称查询" size="small" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-form-item>
        <el-form-item label="项目总负责人">
          <el-input v-model="selectForm.prjLeaderName" placeholder="项目总负责人查询" size="small" clearable>
            <i slot="prefix" class="el-input__icon el-icon-search" />
          </el-input>
        </el-form-item>
        <!-- <el-form-item label="项目类型">
          <el-select v-model="selectForm.prjCategoryId" size="small" placeholder clearable filterable>
            <el-option v-for="item in categoryDic" :key="item.dicId" :label="item.cnName" :value="item.dicId" />
          </el-select>
        </el-form-item> -->
        <el-form-item label="项目等级">
          <el-select v-model="selectForm.prjLevelId" size="small" placeholder clearable filterable>
            <el-option v-for="item in levelDic" :key="item.dicId" :label="item.cnName" :value="item.dicId" />
          </el-select>
        </el-form-item>
        <el-form-item label="状态">
          <el-select v-model="selectForm.isEnabled" size="small" placeholder clearable style="width: 120px"
            @change="fetchData(1)">
            <el-option :key="0" label="禁用" :value="0" />
            <el-option :key="1" label="启用" :value="1" />
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button size="small" type="primary" @click="fetchData(1)">查询</el-button>
          <el-button size="small" type="primary" plain @click="resetBtn">重置</el-button>
        </el-form-item>
      </el-form>
      <el-form style="padding: var(--middle-space) var(--big-space)" size="small">
        <el-button v-if="addEnable" type="primary" size="small" @click="addPrj">
          添加
        </el-button>
        <el-button v-if="downEnable" type="danger" plain size="small" @click="downExecl">
          导出
        </el-button>
      </el-form>
      <el-table :key="prjIndex" v-loading="loading" :data="prjData" :row-style="rowStyle"
        :header-cell-style="headerStyle" element-loading-text="数据加载中" height="100%" highlight-current-row>
        <template slot="empty">
          <img :src="zanwu" alt="" />
          <p style="font-size: 16px; color: #000; margin-top: 36px">暂无消息</p>
        </template>
        <el-table-column type="selection" width="55px"> </el-table-column>
        <el-table-column prop="prjCode" label="项目编号" min-width="130px" show-overflow-tooltip />
        <el-table-column prop="prjName" label="项目名称" min-width="150px" show-overflow-tooltip />

        <el-table-column prop="prjLeaderName" label="项目总负责人" min-width="100px" align="center" />
        <!-- <el-table-column prop="prjLevel" label="项目等级" min-width="100px" align="center" /> -->
        <!-- <el-table-column prop="prjCategory" label="项目类型" min-width="100px" align="center" /> -->
        <el-table-column prop="createDate" label="立项日期" min-width="120px" />
        <el-table-column prop="updateDate" label="最近更新时间" min-width="120px" />
        <el-table-column label="状态" min-width="80px" align="center">
          <template slot-scope="scope">
            <span v-if="scope.row.isEnabled == 0" style="cursor:pointer"
              @click.stop="changeEnabled(scope.row)">禁用</span>
            <span v-if="scope.row.isEnabled == 1" style="cursor:pointer;color: #0ABB87"
              @click.stop="changeEnabled(scope.row)">启用</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="120px" align="center">
          <template slot-scope="scope">
            <span v-if="editEnableShow(scope.row)" class="btn" @click="updatePrj(scope.row)">
              <i class="el-icon-edit-outline" title="编辑"></i></span>
            <span v-if="seeEnableShow(scope.row)" class="btn" @click="check(scope.row)">
              <i class="el-icon-view" title="查看"></i></span>
            <span v-if="deleEnableShow(scope.row)" class="btn" @click="deleteBtn(scope.row)">
              <i class="el-icon-delete" title="删除"></i></span>
          </template>
        </el-table-column>
      </el-table>
      <div class="page">
        <page :page="page" class="el-pagination" @handleSizeChange="handleSizeChange" @handleCurrentChange="fetchData">
        </page>
      </div>
    </div>
  </div>
</template>

<script>
import createProjectService from "@/CommonDP/service/project-service";
import dicService from "@/CommonDP/service/dic-service";
import { checkPermission, disablePrompt } from "@/CommonDP/utils/routeAuth";
import page from "@/CommonDP/components/paging";
import { mapState } from "vuex";
export default {
  components: { page },
  data() {
    return {
      zanwu: require("@/CommonDP/assets/暂无数据.png"),
      loading: true,
      prjData: [],
      prjIndex: 0,
      options: [],
      categoryDic: [],
      levelDic: [],
      selectForm: {
        prjCode: "",
        prjName: "",
        prjLeaderName: "",
        prjStatusId: "",
        prjLevelId: "",
        prjCategoryId: "",
        isEnabled: ""
      },
      page: {
        pageNo: 1,
        pageSize: 10,
        totalCount: 0
      },
      addEnable: checkPermission(this.$allPerms.CREATEPROJECT_ADD),
      editEnable: checkPermission(this.$allPerms.CREATEPROJECT_EDIT),
      seeEnable: checkPermission(this.$allPerms.CREATEPROJECT_SEE),
      deleEnable: checkPermission(this.$allPerms.CREATEPROJECT_DALE),
      queryEnable: checkPermission(this.$allPerms.CREATEPROJECT_QUERY),
      resetEnable: checkPermission(this.$allPerms.CREATEPROJECT_RESET),
      downEnable: checkPermission(this.$allPerms.CREATEPROJECT_DOWN),
      editAllEnable: checkPermission(this.$allPerms.CREATEPROJECT_EDITALL),
      seeAllEnable: checkPermission(this.$allPerms.CREATEPROJECT_SEEALL),
      deleAllEnable: checkPermission(this.$allPerms.CREATEPROJECT_DELEALL)
    };
  },
  computed: {
    setParams() {
      const { prjCode, prjName, prjLeaderName, prjCategoryId, prjLevelId, isEnabled } = this.selectForm;
      const params = {
        prjName,
        prjCode,
        prjLeaderName,
        prjCategoryId,
        prjLevelId,
        isEnabled
      };
      return params;
    },
    ...mapState({
      enterpriseId: (state) => state.enterprise.enterpriseId,
      userInfo: (state) => state.user.userInfo
    })
  },

  mounted() {
    this.getPrjList();
    this.getDicList();
    this.categoryDicList();
    this.levelDicList();
  },
  methods: {
    editEnableShow(val) {
      if (this.isMe(val)) {
        return this.editAllEnable || this.editEnable;
      } else {
        return this.editAllEnable;
      }
    },
    seeEnableShow(val) {
      if (this.isMe(val)) {
        return this.seeAllEnable || this.seeEnable;
      } else {
        return this.seeAllEnable;
      }
    },
    deleEnableShow(val) {
      if (this.isMe(val)) {
        return this.deleAllEnable || this.deleEnable;
      } else {
        return this.deleAllEnable;
      }
    },
    isMe(val) {
      const userId = this.userInfo.userId;
      if (userId === val.prjLeaderId) {
        return true;
      } else {
        return false;
      }
    },
    resetBtn() {
      this.selectForm = {};
      this.page.pageNo = 1;
      this.getPrjList();
    },
    async getDicList() {
      const res = await dicService.getDicList("ProjectStatus");
      this.options = res.data;
    },
    // 项目类别
    async categoryDicList() {
      const res = await dicService.getDicList("PrjType");
      this.categoryDic = res.data || [];
    },
    // 项目等级
    async levelDicList() {
      const res = await dicService.getDicList("PrjLevel");
      this.levelDic = res.data || [];
    },
    async deleteBtn(row) {
      const a = disablePrompt();
      if (a) {
        await this.$confirm(`您确定要删除${row.prjName}项目吗`, "警告", {
          type: "warning"
        });
        const res = await createProjectService.deleteCertainEval(row.prjId);
        if (res.result === "0") this.$message.success("删除成功");
        await this.getPrjList();
        this.$store.dispatch("myProjectsChange");
      }
    },

    // 添加
    addPrj() {
      const a = disablePrompt();
      if (a) {
        this.$router.push({
          name: "createProjectAddEdit",
          query: {
            showType: "add"
          }
        });
      }
    },
    // 修改
    async updatePrj(item) {
      const a = disablePrompt();
      if (a) {
        // 查看是否有编辑该项目的权限
        const res = await createProjectService.getByProjectIdForEdit(item.prjId);
        if (res.result === "0") {
          this.$router.push({
            name: "createProjectAddEdit",
            query: {
              showType: "edit",
              id: item.prjId,
              prjStatusId: item.prjStatusId
            }
          });
        }
      }
    },
    async check(item) {
      const a = disablePrompt();
      if (a) {
        this.$router.push({
          name: "createProjectAddEdit",
          query: { showType: "check", id: item.prjId }
        });
      }
    },
    fetchData(val) {
      this.page.pageNo = val;
      this.getPrjList();
    },
    handleSizeChange(val) {
      this.page.pageSize = val;
      this.page.pageNo = 1;
      this.getPrjList();
    },
    async getPrjList() {
      this.loading = true;
      const {
        page: { pageNo, pageSize },
        enterpriseId
      } = this;
      const params = {
        enterpriseId,
        pageNum: pageNo,
        pageSize,
        ...this.setParams
      };
      const res = await createProjectService.getPrjData(params);
      if (res.result === "0") {
        this.prjData = res.data;
        this.page.pageNo = res.pageIndex;
        this.page.totalCount = res.totalCount;
        this.prjIndex++;
        this.loading = false;
      }
    },
    // 导出
    downExecl() {
      const a = disablePrompt();
      if (a) {
        const { enterpriseId } = this;
        const params = { enterpriseId, pageNum: 1, pageSize: 99999, ...this.setParams };
        createProjectService.exportExcel(params).then((response) => {
          const fileName = "项目导出Excel.xlsx";
          if ("msSaveOrOpenBlob" in navigator) {
            window.navigator.msSaveOrOpenBlob(response, fileName);
            return;
          } else {
            const link = document.createElement("a");
            const blob = response;
            link.style.display = "none";
            link.href = URL.createObjectURL(blob);
            link.setAttribute("download", decodeURI(fileName));
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            this.excelDisable = true;
            this.excelSelect = false;
          }
        });
      }
    },
    rowStyle() {
      return "height:60px";
    },
    headerStyle() {
      return "background-color: #F7F9FF;color:#2E384D;padding:6px 0;height:54px;border-top:1px solid #EFF0F9";
    },
    // 切换项目启用/禁用
    async changeEnabled(row) {
      const isEnabled = row.isEnabled ? 0 : 1; // 0禁用  1启用
      const params = {
        prjId: row.prjId,
        isEnabled
      };
      await createProjectService.changeEnabled(params);
      this.fetchData(this.page.pageNo);
    }
  }
};
</script>

<style lang="scss" scoped>
/deep/.prjDetail {
  height: 500px;
  overflow: auto;
}
.people_class {
  /deep/.el-dialog__body {
    height: 600px;
  }
}

.bottom_left {
  height: 100%;
  overflow: auto;

  .tree_1 {
    font-size: 14px;
  }
}

.notClick {
  cursor: not-allowed;
}

/deep/ .el-tree-node:focus>.el-tree-node__content {
  background: #6d6d6d;
}
</style>
<style lang="stylus" scoped>
#createProject {
  height: 100%;
  box-sizing: border-box;
  min-width: 1680px;
  padding: var(--middle-space);
  display: flex;
  flex-direction: column;

  .header {
    border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    padding: var(--middle-space) var(--big-space);
    color: var(--key-color);
    font-weight: 600;
    font-size: 16px;
    background: #fff;
  }

  .prjList {
    height: 1px;
    flex-grow: 1;
    display: flex;
    flex-direction: column;
    background: #fff;

    .btn {
      cursor: pointer;
      color: #858EBD;
      margin-right: 3px;
    }

    .prjList_form {
      padding: var(--middle-space) var(--big-space) 0;
      border-bottom: 1px solid rgba(211, 217, 232, 0.77);
    }

    .el-form-item {
      margin-bottom: 0;

      /deep/.el-form-item__content {
        height: 40px !important;
      }
    }

    .el-table {
      padding: 0 var(--big-space);
    }

    .page {
      padding: var(--middle-space) var(--big-space);
      .el-pagination {
        float: right;
      }
    }
  }
}
</style>
